import axios from 'axios';
import { store } from '@/store';
import { router } from '@/router';

axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            store.commit('user/resetUserStore');
            localStorage.clear();

            if (router.currentRoute.value.name !== 'public.login') {
                router.push({ name: 'public.login' });
            }
        }

        return Promise.reject(error);
    }
);